
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.385 5.926c0 1.422 1.17 2.575 2.614 2.575s2.615-1.153 2.615-2.575c0-1.422-1.17-2.575-2.615-2.575-1.444 0-2.614 1.153-2.614 2.575zM6 4.378a1.56 1.56 0 011.573 1.549A1.56 1.56 0 016 7.476a1.56 1.56 0 01-1.572-1.55A1.56 1.56 0 016 4.379zm.761 1.549c0 .414-.34.75-.76.75a.755.755 0 01-.761-.75c0-.414.34-.75.76-.75s.761.336.761.75zM9.01 7.943l.469 1.522A4.875 4.875 0 0011 5.927c0-2.419-1.77-4.43-4.105-4.846L6.563 0H5.202l-.345 1.131C2.647 1.64 1 3.594 1 5.927c0 1.31.52 2.502 1.368 3.384L1.549 12h1.232l.618-1.867c.549.33 1.167.56 1.83.66V12h1.368V9.463A3.718 3.718 0 015.23 9.43a3.648 3.648 0 01-2.377-1.707l.005.01a3.525 3.525 0 01-.494-1.806A3.58 3.58 0 014.375 2.72 3.67 3.67 0 016 2.344c.483 0 .943.093 1.364.26C8.7 3.136 9.64 4.424 9.64 5.928a3.53 3.53 0 01-.63 2.017 3.634 3.634 0 01-2.412 1.52v1.354a5.02 5.02 0 001.84-.59L9.027 12h1.231L9.01 7.943z"}})])
          )
        }
      }
    